import { findPrinterInterface } from "./findPrinterInterface";
import { isElectron, getIpcRenderer } from "./electronBridge";

let cachedPrinterDevice = null; // garde le périphérique USB autorisé

export const PrintAction = async (
  printData,
  openDrawer = false,
  ticket = true
) => {
  try {
    if (isElectron()) {
      const ipcRenderer = getIpcRenderer();
      if (ticket) {
        const bytes =
          printData instanceof Uint8Array ? printData : new Uint8Array(printData);
        await ipcRenderer.invoke("printer:print", bytes);
      }

      if (openDrawer) {
        console.log("Tiroire");
        const drawerCmdPin0 = new Uint8Array([0x1b, 0x70, 0x00, 0x19, 0xfa]);
        const drawerCmdPin1 = new Uint8Array([0x1b, 0x70, 0x01, 0x19, 0xfa]);
        await ipcRenderer.invoke("printer:print", drawerCmdPin0);
        await ipcRenderer.invoke("printer:print", drawerCmdPin1);
      } else {
        console.log("no Tiroire");
      }

      return true;
    }

    if (!cachedPrinterDevice) {
      const devices = await navigator.usb.getDevices();
      if (devices.length === 0) {
        throw new Error(
          "Aucune imprimante autorisée. Veuillez connecter l'imprimante via le bouton."
        );
      }
      cachedPrinterDevice = devices[0];
    }

    const device = cachedPrinterDevice;
    if (!device.opened) await device.open();
    if (!device.configuration) await device.selectConfiguration(1);

    const printerInterface = await findPrinterInterface(device);
    if (!printerInterface) throw new Error("Aucune interface imprimante claimable trouvée sur ce périphérique");

    const outEndpoint = printerInterface.outEndpoint;
    if (ticket) {
      // Convertir les données en Uint8Array si besoin
      const bytes =
        printData instanceof Uint8Array ? printData : new Uint8Array(printData);

      // 1️⃣ Envoyer l'impression
      await device.transferOut(outEndpoint.endpointNumber, bytes);
    }

    // 2️⃣ Envoyer le kick drawer si demandé
    if (openDrawer) {
      console.log("Tiroire");
      // Le tiroir peut être câblé sur la broche 2 (m=0) ou 5 (m=1) du connecteur RJ11 :
      // on pulse les deux pour ne pas dépendre du câblage exact.
      const drawerCmdPin0 = new Uint8Array([0x1b, 0x70, 0x00, 0x19, 0xfa]);
      const drawerCmdPin1 = new Uint8Array([0x1b, 0x70, 0x01, 0x19, 0xfa]);
      const result0 = await device.transferOut(outEndpoint.endpointNumber, drawerCmdPin0);
      console.log("Drawer pin0 transfer result:", result0.status, result0.bytesWritten);
      const result1 = await device.transferOut(outEndpoint.endpointNumber, drawerCmdPin1);
      console.log("Drawer pin1 transfer result:", result1.status, result1.bytesWritten);
    } else {
      console.log("no Tiroire");
    }

    return true;
  } catch (err) {
    console.error("Erreur lors de l'impression :", err);
    return false;
  }
};